export const ORGANIZATIONS_TAG = 'organizationManagement';
export const ORGANIZATIONS_BASE_PATH = 'management/organizations';
export const ORGANIZATIONS_API_PATH = 'management';
